export const CONSENT_KEY = 'zyvanelix_consent_v2';

export const DEFAULT_CONSENT = {
  necessary: true,
  analytics: false,
  ads: false,
  personalization: false,
};

export function readConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

export function saveConsent(consent) {
  const payload = { ...consent, ts: Date.now() };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(payload));
  } catch (e) {}
  applyConsent(payload);
  return payload;
}

export function applyConsent(consent) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }

  const grant = (bool) => (bool ? 'granted' : 'denied');

  gtag('consent', 'update', {
    ad_storage: grant(consent.ads),
    ad_user_data: grant(consent.ads),
    ad_personalization: grant(consent.ads),
    analytics_storage: grant(consent.analytics),
    functionality_storage: 'granted',
    personalization_storage: grant(consent.personalization),
    security_storage: 'granted',
  });

  window.dataLayer.push({ event: 'cookie_consent_update', consent });
}

export function acceptAll() {
  return saveConsent({ necessary: true, analytics: true, ads: true, personalization: true });
}

export function rejectAll() {
  return saveConsent({ necessary: true, analytics: false, ads: false, personalization: false });
}
